export function getApiValidationErrors(error) {
  if (error?.response?.status === 422 && error?.response?.data?.errors) {
    return error.response.data.errors;
  }

  return {};
}

export function getRegisterErrorMessage(error) {
  const status = error?.response?.status;

  if (status === 422) {
    return "Please review the entered details and try again.";
  }

  if (status === 500) {
    return "We could not complete your registration right now. Please try again shortly.";
  }

  if (!error?.response) {
    return "Unable to connect at the moment. Please check your internet connection and try again.";
  }

  return "We could not create your account right now. Please try again.";
}

export function getLoginOtpRequestErrorMessage(error) {
  const status = error?.response?.status;

  if (status === 404) {
    return "We could not find an account with this email address.";
  }

  if (status === 423) {
    return "Your account is temporarily locked. Please try again later.";
  }

  if (status === 422) {
    return "Please enter a valid email address and try again.";
  }

  if (status === 500) {
    return "We could not send your verification code right now. Please try again shortly.";
  }

  if (!error?.response) {
    return "Unable to connect at the moment. Please check your internet connection and try again.";
  }

  return "We could not continue with login right now. Please try again.";
}

export function getVerifyOtpErrorMessage(error) {
  const status = error?.response?.status;

  if (status === 400) {
    return "The verification code is incorrect or has expired. Please try again.";
  }

  if (status === 422) {
    return "Please enter the verification code correctly and try again.";
  }

  if (status === 500) {
    return "We could not verify your code right now. Please try again shortly.";
  }

  if (!error?.response) {
    return "Unable to connect at the moment. Please check your internet connection and try again.";
  }

  return "We could not verify your code right now. Please try again.";
}

export function getResendOtpErrorMessage(error) {
  const status = error?.response?.status;

  if (status === 422) {
    return "We could not resend the verification code. Please check your email address and try again.";
  }

  if (status === 500) {
    return "We could not resend the verification code right now. Please try again shortly.";
  }

  if (!error?.response) {
    return "Unable to connect at the moment. Please check your internet connection and try again.";
  }

  return "We could not resend the verification code right now. Please try again.";
}